import { SVGProps } from 'react';
const SvgHeadingH6 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15.402 14.525A2.974 2.974 0 0 0 16.5 18.6a3.01 3.01 0 0 0 4.099-1.092 2.974 2.974 0 0 0-1.099-4.075 3.01 3.01 0 0 0-4.098 1.092Zm0 0L19 8M3 5v7m0 0v7m0-7h8m0-7v7m0 0v7"
    />
  </svg>
);
export default SvgHeadingH6;
